<template>
  <div>{{ t('supportRequest.introduction') }}</div>
</template>

<script setup lang="ts">
import { t } from '../../composables/Translation'
</script>

<style lang="scss" scoped>
div {
  padding-bottom: 16px;
}
</style>
